import { Page_embedSlugS_productizedService$key } from '#app/__generated__/relay/Page_embedSlugS_productizedService.graphql.js';
import { Page_embedSlugSQuery } from '#app/__generated__/relay/Page_embedSlugSQuery.graphql.js';
import { NotFound } from '#app/components/NotFound/NotFound.js';
import { EmbeddedBuyNowLayout } from '#app/features/productizedService/embed/layouts/EmbeddedBuyNowLayout.js';
import { type PageProps } from '#app/types/router.js';
import { graphql, useFragment, usePreloadedQuery } from '@contra/relay';
import { Helmet } from 'react-helmet-async';
import { createGlobalStyle } from 'styled-components';

type ServicePageProps = PageProps<'/s/@slug/embed', Page_embedSlugSQuery>;

// This is necessary so the card is rendered matching whatever background is behind it
const GlobalStyle = createGlobalStyle`
  html {
    overflow: hidden !important;
  }

  body {
    background: transparent !important;
  }
`;

export const Page = ({ preloaded }: ServicePageProps) => {
  const data = usePreloadedQuery<Page_embedSlugSQuery>(
    graphql`
      query Page_embedSlugSQuery($slug: String!) {
        productizedServiceBySlug(slug: $slug) {
          ...Page_embedSlugS_productizedService
        }
      }
    `,
    preloaded,
  );

  const { productizedServiceBySlug: node } = data;

  const service = useFragment<Page_embedSlugS_productizedService$key>(
    graphql`
      fragment Page_embedSlugS_productizedService on ProductizedService {
        title
        userProfile {
          firstName
          lastName
        }
        ...EmbeddedBuyNowLayout_productizedService
      }
    `,
    node,
  );

  if (!service || !node) return <NotFound />;

  return (
    <>
      <Helmet>
        <title>{`${service.title} by ${service.userProfile.firstName} ${service.userProfile.lastName}`}</title>
        <meta
          content="noindex"
          name="robots"
        />
      </Helmet>
      <GlobalStyle />
      <EmbeddedBuyNowLayout productizedServiceRef={service} />
    </>
  );
};
